var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#00DC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1642 53.5398C63.7634 52.7725 45.2176 53.4302 45.2176 45.045C45.2176 40.0578 53.0408 37.3176 60.098 37.3176C71.4772 37.3176 79.0815 41.8664 81.2698 43.4009L90.8984 33.7553C88.0536 31.5083 77.4403 24 60.098 24C44.2329 24 30.0636 32.2755 30.0636 45.5383C30.0636 65.8709 54.5726 65.8709 64.7482 66.8574C70.9301 67.515 76.565 67.9535 76.565 74.0368C76.565 79.6817 67.8665 82.8604 61.1375 82.8604C50.196 82.8604 43.6858 79.2981 37.285 73.5435L27 83.7372C36.4097 92.8896 48.5 97 60.3169 97C78.6439 97 91.9925 88.8341 91.9925 72.5571C92.2661 61.9249 85.0447 55.4032 70.1642 53.5398Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sage.ff46e360b0335757848a1153b6848b47.svg";